"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Selector = function Selector(_ref) {
  var changeFieldData = _ref.changeFieldData,
      defaultValue = _ref.defaultValue,
      translateNs = _ref.translateNs,
      saveDefault = _ref.saveDefault,
      savedValue = _ref.savedValue,
      fields = _ref.fields,
      label = _ref.label,
      name = _ref.name,
      t = _ref.t;
  // Save a default Value
  // Because even though a value has already been showed in the selection,
  // but it is still not passed to the context
  (0, _react.useEffect)(function () {
    saveDefault(name, savedValue, defaultValue);
  }, [savedValue, defaultValue, name, saveDefault]);

  var _React$useState = _react.default.useState(''),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      selectedValue = _React$useState2[0],
      setSelectedValue = _React$useState2[1];

  var handleChange = function handleChange(event) {
    setSelectedValue(event.target.value);
    changeFieldData(event, '', name);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
    id: label,
    labelId: label,
    value: selectedValue || savedValue || defaultValue,
    onChange: handleChange,
    label: label,
    name: name,
    children: Object.entries(fields).map(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          key = _ref3[0],
          field = _ref3[1];

      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem.default, {
        name: key,
        value: field,
        children: t("".concat(translateNs[field]))
      }, key);
    })
  }, label);
};

var _default = Selector;
exports.default = _default;